import { CommonAdapter } from '@adapters';
import { FetchSystemInfoResponse } from '@dto';
export class FetchCommonTotalUseCase {
  constructor(private readonly commonAdapter: CommonAdapter) {
    this.commonAdapter = commonAdapter;
  }
  public async execute(): Promise<FetchSystemInfoResponse | null> {
    return await this.commonAdapter.fetchSystemInfo();
  }
}
